module.exports = __webpack_public_path__ + "img/kayzoo_0.ddfc7b33.jpg";